import { fetch } from '@/plugin/axiosNoLogin'
const serverName = '/maintain'

export function getEmergencyRescue(params) {
  return fetch({
    url: serverName + '/api/emergencyRescue',
		method: 'GET',
		params
  })
}